/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditUserCommand } from '../../models/edit-user-command';
import { UserDetailsDtoApiResponse } from '../../models/user-details-dto-api-response';

export interface EditUserAsync$Params {
  id: number;
      body?: EditUserCommand
}

export function editUserAsync(http: HttpClient, rootUrl: string, params: EditUserAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editUserAsync.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDetailsDtoApiResponse>;
    })
  );
}

editUserAsync.PATH = '/api/user/{id}';
